import { useState } from "react";
import { Breadcrumbs } from "../breadcrumbs";
import { CreateReimbursementForm } from "../forms/create-reimbursement-form";
import { ReimbursementsTable } from "../tables/reimbursements-table";
import { Button } from "../ui/button";
import {
	Sheet,
	SheetContent,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from "../ui/sheet";

export function ReimbursementsPage() {
	const [open, setOpen] = useState(false);

	return (
		<div className="space-y-2">
			<Breadcrumbs />
			<div className="flex flex-col">
				<div className="flex justify-between">
					<h2>Reimbursement Requests</h2>
					<Sheet open={open} onOpenChange={setOpen}>
						<SheetTrigger render={<Button />}>
							Submit Reimbursement
						</SheetTrigger>
						<SheetContent>
							<SheetHeader>
								<SheetTitle>Submit Reimbursement Request</SheetTitle>
							</SheetHeader>
							<div className="px-4 overflow-y-auto pb-12">
								<CreateReimbursementForm onComplete={() => setOpen(false)} />
							</div>
						</SheetContent>
					</Sheet>
				</div>
				<ReimbursementsTable />
			</div>
		</div>
	);
}
